<div class="header-wrapper">
    <h1 mat-dialog-title class="title">{{ data.title ? (data.title | translate | async) : ("title.loading" | translate | async) }}</h1>
    <p class="subtitle" *ngIf="data.subtitle">{{ data.subtitle | translate | async }}</p>
</div>
<mat-dialog-content class="mat-typography content-wrapper">
    <div class="spinner-wrapper">
        <mat-spinner diameter="32"></mat-spinner>
    </div>
</mat-dialog-content>
